<ion-grid fixed>
  <ion-row>
    <ion-col size="12">
      <p class="ion-text-center instructions-title">Escoge tus boletas</p>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col sizeXs="10" sizeSm="8" offsetSm="1" sizeLg="5" offsetLg="3">
      <ion-row class="ticket-scroll">
        <ion-fab-button
          size="small"
          class="letter-button"
          *ngFor="let item of limitedTickets; let i = index"
          [color]="ticketSelected === i ? 'primary' : ticketValid[i] ? 'tertiary' : 'light'"
          (click)="selectTicket.emit(i)"
        >
          <ion-label>{{ letras[i] }}</ion-label>
        </ion-fab-button>
      </ion-row>
    </ion-col>
    <ion-col sizeXs="2" sizeMd="1">
      <ion-row class="add-ticket">
        <ion-button shape="round" fill="outline" (click)="addTicket.emit()" [disabled]="!canAddMore()">
          <ion-icon slot="icon-only" name="add"></ion-icon>
        </ion-button>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>
